/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetGithubRepoRequest = { repo: string };

export const GetGithubRepoRequest$zodSchema: z.ZodType<GetGithubRepoRequest> = z
  .object({
    repo: z.string().describe("目标仓库的标识，格式为 `owner/repo`。"),
  });

/**
 * 上游 GitHub API 出错或不可用。响应中会包含来自上游的原始错误信息，便于排查问题。
 */
export type GetGithubRepoBadGatewayResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetGithubRepoBadGatewayResponseBody$zodSchema: z.ZodType<
  GetGithubRepoBadGatewayResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe(
  "上游 GitHub API 出错或不可用。响应中会包含来自上游的原始错误信息，便于排查问题。",
);

/**
 * 请求参数缺失或格式错误。请确保 `repo` 参数已提供且格式为 `owner/repo`。
 */
export type GetGithubRepoBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
};

export const GetGithubRepoBadRequestResponseBody$zodSchema: z.ZodType<
  GetGithubRepoBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
}).describe(
  "请求参数缺失或格式错误。请确保 `repo` 参数已提供且格式为 `owner/repo`。",
);

export type Collaborator = {
  login?: string | undefined;
  name?: string | undefined;
  email?: string | undefined;
  url?: string | undefined;
};

export const Collaborator$zodSchema: z.ZodType<Collaborator> = z.object({
  email: z.string().optional(),
  login: z.string().optional(),
  name: z.string().optional(),
  url: z.string().optional(),
});

export type Maintainer = {
  login?: string | undefined;
  name?: string | undefined;
  email?: string | undefined;
  url?: string | undefined;
};

export const Maintainer$zodSchema: z.ZodType<Maintainer> = z.object({
  email: z.string().optional(),
  login: z.string().optional(),
  name: z.string().optional(),
  url: z.string().optional(),
});

/**
 * 仓库最新发布版本信息，如果没有 Release 则为 null。可用于实现应用更新检查功能。
 */
export type LatestRelease = {
  tag_name?: string | undefined;
  name?: string | undefined;
  published_at?: string | undefined;
  html_url?: string | undefined;
  prerelease?: boolean | undefined;
  draft?: boolean | undefined;
};

export const LatestRelease$zodSchema: z.ZodType<LatestRelease> = z.object({
  draft: z.boolean().optional(),
  html_url: z.string().optional(),
  name: z.string().optional(),
  prerelease: z.boolean().optional(),
  published_at: z.iso.datetime({ offset: true }).optional(),
  tag_name: z.string().optional(),
}).describe(
  "仓库最新发布版本信息，如果没有 Release 则为 null。可用于实现应用更新检查功能。",
);

/**
 * 成功获取仓库信息。
 */
export type GetGithubRepoResponseBody = {
  full_name?: string | undefined;
  description?: string | undefined;
  homepage?: string | undefined;
  default_branch?: string | undefined;
  primary_branch?: string | undefined;
  default_branch_sha?: string | undefined;
  visibility?: string | undefined;
  archived?: boolean | undefined;
  disabled?: boolean | undefined;
  fork?: boolean | undefined;
  language?: string | undefined;
  topics?: Array<string> | undefined;
  license?: string | undefined;
  stargazers?: number | undefined;
  forks?: number | undefined;
  open_issues?: number | undefined;
  watchers?: number | undefined;
  pushed_at?: string | undefined;
  created_at?: string | undefined;
  updated_at?: string | undefined;
  languages?: { [k: string]: number } | undefined;
  collaborators?: Array<Collaborator> | null | undefined;
  maintainers?: Array<Maintainer> | undefined;
  latest_release?: LatestRelease | null | undefined;
};

export const GetGithubRepoResponseBody$zodSchema: z.ZodType<
  GetGithubRepoResponseBody
> = z.object({
  archived: z.boolean().optional(),
  collaborators: z.array(z.lazy(() => Collaborator$zodSchema)).nullable()
    .optional(),
  created_at: z.iso.datetime({ offset: true }).optional(),
  default_branch: z.string().optional(),
  default_branch_sha: z.string().optional(),
  description: z.string().optional(),
  disabled: z.boolean().optional(),
  fork: z.boolean().optional(),
  forks: z.int().optional(),
  full_name: z.string().optional(),
  homepage: z.string().optional(),
  language: z.string().optional(),
  languages: z.record(z.string(), z.int()).optional(),
  latest_release: z.lazy(() => LatestRelease$zodSchema).nullable().optional(),
  license: z.string().optional(),
  maintainers: z.array(z.lazy(() => Maintainer$zodSchema)).optional(),
  open_issues: z.int().optional(),
  primary_branch: z.string().optional(),
  pushed_at: z.iso.datetime({ offset: true }).optional(),
  stargazers: z.int().optional(),
  topics: z.array(z.string()).optional(),
  updated_at: z.iso.datetime({ offset: true }).optional(),
  visibility: z.string().optional(),
  watchers: z.int().optional(),
}).describe("成功获取仓库信息。");

export type GetGithubRepoResponse =
  | GetGithubRepoResponseBody
  | GetGithubRepoBadRequestResponseBody
  | GetGithubRepoBadGatewayResponseBody;

export const GetGithubRepoResponse$zodSchema: z.ZodType<GetGithubRepoResponse> =
  z.union([
    z.lazy(() => GetGithubRepoResponseBody$zodSchema),
    z.lazy(() => GetGithubRepoBadRequestResponseBody$zodSchema),
    z.lazy(() => GetGithubRepoBadGatewayResponseBody$zodSchema),
  ]);
